export default __webpack_public_path__ + "static/media/credit-card.9ad6e27d.svg";